import React from "react";

import { useParams } from "react-router-dom";

import PostedTable from "../components/PostedTable";

const BuyInAuction = () => {

  const params = useParams();

  return <PostedTable id={params.id} />;
}

export default BuyInAuction;